<script setup lang="ts">
import { Card, CardContent } from '@/components/ui/card'
import { toast } from '~/utils/sonner'
const visitorSession = useVisitorSession()
const user = useUser()
interface Props {
  modelValue?: string,
  shadow?: boolean,
}

const prop = withDefaults(defineProps<Props>(), {
  modelValue: 'login',
  // defaultState: 'login',
  shadow: false
})

const emit = defineEmits(['update:modelValue'])

const $i18n = useI18n()
const $t = $i18n.t
const loginInfo = ref({
  email: '',
  password: '',
  ref: ''
})
const loggingIn = ref(false)
const state = computed({
  get() {
    return prop.modelValue
  },
  set(value) {
    console.log('setting state to', value)
    emit('update:modelValue', value)
  },
})
const emailToken = ref('')
const titleText = computed(() => {
  switch (state.value) {
    case 'signup':
      return $t('login.signup_button')
    case 'login':
      return $t('login.button')
    case 'reset':
      return $t('login.reset.button')
    default:
      return ''
  }
})
const mailLink = computed(() => {
  return `mailto:passwordchange@hi.pandafan.email?subject=${emailToken.value}:123123`
})

async function onSubmit() {
  if (state.value !== 'reset' && (!loginInfo.value.email || !loginInfo.value.password)) {
    return useDialog().alert({
      title: 'Error',
      body: $t('login.email_or_password_please'),
      confirmButtonText: $t('ok'),
    })
  }
  loggingIn.value = true
  try {
    await submitFunc[state.value]()
    useTryTrackEvent(state.value, {
      // action: state.value,
      status: 'success',
    })
    loggingIn.value = false
    afterWards()
  } catch (e: any) {
    console.log('onSubmit:', state.value, 'error:', e)
    console.log('e.data', e.data)
    console.log('e.message', e.message, 'e.request:', e.request, 'e.stack:', e.stack)
    useTryTrackEvent(state.value + '_error', {
      catched: true,
      status: 'error',
      error: e.message,
      action: state.value,
    })
    if (!e.data && e.message.startsWith('Failed to fetch (')) {
      // e.message = 
      return toast({
        title: $t(`errors.network_err.title`),
        description: $t(`errors.network_err.message`) + e.stack,
        variant: 'destructive'
      })
    }

    // when request going through nuxt proxy, it will wrap the returned error data into its own error object
    // so we need to unwrap it by accessing extra .data property
    // seems to only happen in cloudflare workers 🤔️
    // make this error message extraction a standard functon?
    // useUnwrapError?
    const realErr = e.data?.data || e.data
    const errDetail = realErr?.detail || e.data?.error
    const detailMsg = errDetail ? JSON.stringify(errDetail, null, 2) : ''
    toast({
      title: $t(`errors.${realErr?.message || e.message || e}.title`),
      description: $t(`errors.${realErr?.message || e.message || e}.message`) + detailMsg,
      variant: 'destructive'
    })
  }
  // console.log('onSubmit end')
  loggingIn.value = false
  // console.log(loggingIn.value)
}

const submitFunc: any = {
  signup: async () => {
    const data = await user.signUp(loginInfo.value)
    console.log('submit: signup', data)
    if (data.jwt_token) {
      visitorSession.setToken(data.jwt_token)
    }
    return data
  },
  login: async () => {
    console.log('submit login.')
    const data = await visitorSession.login({
      email: loginInfo.value.email,
      password: loginInfo.value.password
    })
    console.log('login result', data)
  },
  reset: async () => {
    console.log('submit reset.')
    if (!loginInfo.value.email) {
      await useDialog().alert({
        title: 'Error',
        body: $t('login.email_please'),
        confirmButtonText: $t('ok'),
      })
      return (loggingIn.value = false)
    }
    try {
      const data = await user.requestPasswordReset({ email: loginInfo.value.email })
      useDialog().alert({
        title: $t('login.check_email'),
        body: $t('login.reset.reset_requested'),
        confirmButtonText: $t('ok'),
      })
      emailToken.value = data?.email_token as string
    } catch (err: Error | any) {
      if (err.data?.message === 'illegal email' || err.data?.message === 'not found') {
        return useDialog().alert({
          title: 'Error',
          body: $t('login.not_found'),
          confirmButtonText: $t('ok'),
        })
      }
      throw err
    }
  }
}
const afterWards = () => {
  console.log('afterWards', state.value)
  if (!['signup', 'login'].includes(state.value)) {
    console.log('gonna return.')
    return
  }
  const $route = useRoute()
  console.log('$route.name', $route.name)
  if (['pricing', 'knowledges-knowledgeid'].includes(($route.name as string || '')?.toLowerCase())) {
    // this.$router
    // 关闭自己
    // 确认下这样parent value是否更新
    // localVisible.value = false
    window?.location?.reload()
  } else {
    navigateTo(`/dashboard/${visitorSession.id}`)
  }
}
</script>

<template lang="pug">
.sign-form(:class="{ shadow: prop.shadow }")
  div.flex.items-center.justify-center
    div.unselectable.hidden-xs.illustration.flex.items-center.justify-center(class="sm:w-5/12")
      img.unselectable.svg-unselectable(src="https://alicloud-assets.oss-accelerate.aliyuncs.com/img/authentication3.svg" loading="lazy")
    div.p-2.flex.items-center.justify-center(class="sm:w-7/12 w-full lg:pr-4")
      //- h1 Hehe
      //- Logo
      Card.token-text(v-show="state == 'reset' && emailToken")
        CardContent
          h5 {{ $t('login.reset.alt.a') }}
            br
            code {{ emailToken }}:
            | {{ $t('login.reset.alt.b') }}
            br
            | {{ $t('login.reset.alt.c') }}
          br
          a(:href="mailLink") passwordchange@hi.pandafan.email
          //- center
          br
          | {{ $t('login.reset.alt.d') }}&nbsp;
          br
          p {{ emailToken }}:123123
          |  {{ $t('login.reset.alt.e') }}&nbsp;
          code 123123
          br
          | {{ $t('login.reset.alt.f') }}
      form.w-full(@submit.prevent.stop="onSubmit")
        //- el-form-item(label='注册邮箱')
        div.gap-y-3
          div.gap-y-1
            p {{ $t('login.email') }}
            Input.email(v-model="loginInfo.email", type="email", placeholder="m@example.com")
          div.gap-y-1
            //- el-form-item(label='账号密码')
            p(v-if="state !== 'reset'") {{ $t('login.password') }}
            Input.password(v-model='loginInfo.password', type="password", :placeholder="$t('login.password')" v-if="state !== 'reset'")
          div.gap-y-1
            p(v-if="state == 'signup'") {{ $t('login.ref') }}
            Input.ref(v-model='loginInfo.ref', type="text", :placeholder="$t('login.ref')", v-if="state == 'signup'")

        //- center
        div.mt-4
          .login(v-if="state === 'login'")
            div.flex.flex-col.gap-2
              Button.mb-2.w-full.text-lg(native-type='submit', variant="default", :loading="loggingIn") {{ $t('login.button') }}
              div.flex.items-center.justify-between
                a.text-primary(@click="state = 'reset'") {{ $t('login.reset.text') }}
                a.text-primary(@click="state = 'signup'") {{ $t('login.signup_hint') }}
          .sign-up(v-if="state === 'signup'")
            div.flex.flex-col.gap-2
              Button.mb-2.w-full.text-lg(native-type='submit' :loading="loggingIn") {{ $t('login.signup_button') }}
              div.text-right.w-full
                a.text-primary(@click="state = 'login'") {{ $t('login.login_hint') }}
          .reset(v-if="state === 'reset'")
            div.flex.flex-col.gap-2
              Button.mb-2.w-full.text-lg(native-type='submit', variant="warning", :loading="loggingIn") {{ $t('login.reset.button') }}
              div.text-right.w-full
                a.text-primary(@click="state = 'login'") {{ $t('login.text') }}
</template>

<style lang="postcss">
.sign-form {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  border-radius: 2.625rem !important;

  @media (max-width: 768px) {
    border-radius: 0 !important;
  }

  /* padding: 20px; */
  /* background-color: var(--modal-bg) !important; */

  &.shadow {
    box-shadow: var(--shadow-large) !important;
  }

  /* Make all SVGs and images unselectable */
  img,
  svg {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  .svg-unselectable {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    pointer-events: none !important;
    -webkit-user-drag: none !important;
  }

  a {
    /* margin-bottom: 20px; */
    font-weight: 700;
    font-size: 15px;
    display: block;
  }

  form {
    text-align: left;
  }

  --input-radius: 4px;

  @media (max-width: 768px) {
    width: 100% !important;
    margin-top: 0vh !important;
  }


  .illustration {
    /* background: transparent !important; */
    padding: -20px 20px 0 20px;

    img {
      margin: -10px -10px 0 -20px;
      transform: scale(1.1);
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  /* Glossy button styles */
  button[type="submit"],
  .btn-primary {
    background: linear-gradient(135deg,
        rgba(126, 211, 33, 0.9) 0%,
        rgba(126, 211, 33, 0.7) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(126, 211, 33, 0.3);
    box-shadow:
      0 4px 20px 0 rgba(126, 211, 33, 0.25),
      inset 0 1px 0 0 rgba(255, 255, 255, 0.3),
      inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.3) 50%,
          transparent 100%);
      transition: left 0.5s ease;
    }

    &:hover:not(:disabled) {
      background: linear-gradient(135deg,
          rgba(126, 211, 33, 1) 0%,
          rgba(126, 211, 33, 0.8) 100%);
      transform: translateY(-1px);
      box-shadow:
        0 6px 24px 0 rgba(126, 211, 33, 0.35),
        inset 0 1px 0 0 rgba(255, 255, 255, 0.4),
        inset 0 -1px 0 0 rgba(0, 0, 0, 0.15);

      &::before {
        left: 100%;
      }
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow:
        0 2px 12px 0 rgba(126, 211, 33, 0.2),
        inset 0 1px 0 0 rgba(255, 255, 255, 0.2),
        inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
